/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_EmptyInputs */



/**
* | output |
* | --- |
* | "Standings will appear when tournaments finish." |
*
* @param {League_Standings_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_empty = /** @type {((inputs?: League_Standings_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le classement apparaîtra lorsque des tournois seront terminés.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las clasificaciones aparecerán cuando terminen los torneos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As classificações aparecerão quando os torneios terminarem.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le classifiche appariranno quando i tornei saranno terminati.")
	return /** @type {LocalizedString} */ ("Standings will appear when tournaments finish.")
});